export default {
  subtitle: "",
  paragraph: "Once you get the correct bank account information from the customer you must send a request to update it using the following endpoint, so the API will then try again. If it succeeds, the API sends the 'wire_created' webhook. ",
  path: "webhooks_wire_correction",
  request: {
    method: "PUT",
    endpoint: "/wires/:id/update_bank_account",
    payload: {
      "bank_account": {
        "currency": "BRL",
        "bank": {"code": "260","name": "Nu Pagamentos S.A."},
        "branch_number": "1",
        "account_number": "36725089",
        "owner_document_number": "Person name",
        "owner_name": "Person name",
        "branch_country": "BR",
        "account_type": "conta-corrente"
      }
    },
    responses: {
      "currency": "BRL",
      "id": "51ca5a65-bbd2-433d-8527-1cb36bf4a1c2",
      "inserted_at": "2025-07-10T18:39:43.580056",
      "status": "waiting_confirmation",
      "to_bank_account": {
        "aba": null,
        "account_number": "456",
        "account_type": "conta-corrente",
        "bank": {
          "code": "012",
          "country": "BRA",
          "id": "04bf9dc2-f189-4a1f-929d-5478def064e9",
          "ispb": "04866275",
          "name": "Banco Inbursa S.A.",
          "swift": null
        },
        "branch_country": "BRA",
        "branch_number": "8221",
        "company": {
          "company_name": "Subject",
          "document_number": "67645727390",
          "document_type": "cpf",
          "fiscal_country": "BR",
          "id": "31288cc8-e106-4aec-8437-85758ba671c0",
          "phone_number": null,
          "social_name": "Subject"
        },
        "currency": "BRL",
        "iban": null,
        "id": "79247afc-b15d-441c-af72-08f2013fd58e",
        "intermediary_bank_account": null,
        "nickname": null,
        "owner_document_number": "67645727390",
        "owner_document_type": null,
        "owner_name": "Subject",
        "pix_info": null,
        "routing_number": null
      },
      "unretryable": false,
      "value": "500.0"
    }
  },
  domainsProperties: [
    {
      name: "account_type",
      values: "'conta-corrente', 'poupanca'"
    }
  ],
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/WebhooksWireCorrection.js